(function () {
	Vue.component('nominow-input-textarea', {
		model: {
			prop: 'value',
			event: 'change'
		},
		props: {
			value: { //this is intentionally left empty it could be string, boolean, null or even object...
				default: null
			},
			label: {
				type: String,
				required: true,
				default: 'Label'
			},
			name: {
				type: String,
				required: false
			},
			required: {
				type: Boolean,
				required: false
			},
			regex: {
				type: String,
				required: false
			},
			regexMessage: {
				type: String,
				required: false
			},
			css: {
				type: String,
				required: false
			},
			wrap: {
				type: String,
				required: false,
				default: 'hard'
			},
			rows: {
				type: Number,
				required: false
			},
			cols: {
				type: Number,
				required: false
			},
			nomui: {
				type: Boolean,
				required: false
			}
		},
		template: `
        <div class="field" :class="{'mui-textfield' : (!nomui)}">
		<textarea :class="css" :name="name || label" :wrap="wrap" :value="value" @blur="$emit('change', $event.target.value)" @input="$emit('change', $event.target.value)" :data-val="(required || regex ? 'true' : null)" :data-val-required="required ? 'Required' : ''" :data-val-regex="regexMessage" :data-val-regex-pattern="regex" :rows="rows" :cols="cols" >{{value}}</textarea>
        <label>{{label}}</label>
        </div>
        `
	});
})();
